import React, {useContext, useMemo} from 'react'
import PopEventDisplay from '../PopEventDisplay/PopEventDisplay'
import moment from 'moment'
import './Pill.scss'
import usePop from '../../../../utils/usePop'
import CalendarEventReservationPopup from '../../../CalendarEventPopup'
import CalendarEventGroupDatePopup from '../../../CalendarEventGroupDatePopup'
import CalendarEventActionDatePopup from '../../../CalendarEventActionDatePopup'
import {ReservationContext} from '../../../../context/Reservation'
import CalendarEventDateDriveActionPopup from '../../../CalendarEventDateDrivenActionPopup'

const Pill = ({data, headers = {primary: [], secondary: []}, breakpoint = {}}) => {
  const {entityFields} = useContext(ReservationContext)
  const stateEventDisplay = usePop()
  const stateCalEv = usePop()

  /**
   *  Hash through background for overdue events start after end date
        Start of hash will have "Overdue" text in red
   *  Requested - Rejected events will not display
   */
  const {border_style, border_color, background_color, overdue_width} = useMemo(() => {
    /**
     *  Color of event based upon calendar view selected (Default)
     */
    let border_style = 'solid'
    let border_color = data.data[0].color || '#fff'
    let background_color = data.data[0].color || '#fff'
    let overdue_width = 0
    if (data.data.length === 1) {
      const item = data.data[0]
      if (data.data[0].type === 'SystemReservationAction') {
        /**
         *  Dotted outline for awaiting manager approval
         */
        if (item.status === 'requested' && item.states === 'pending') {
          border_style = 'dotted'
          border_color = item.color
          background_color = item.color + '22'
          /**
         * Solid outline for manager approved events
            Or events not requiring approval
        */
        } else if (item.status === 'upcoming') {
          border_style = 'solid'
          border_color = item.color
          background_color = item.color + '22'
        }
      }
      // check overdue
      if (item.end.valueOf() < data.endSec) {
        let _diff = data.endSec - item.end.valueOf()
        let _diff2 = data.endSec - data.startSec
        let _perc = (_diff / _diff2) * 100
        overdue_width = Math.min(_perc, 100)
      }
    }

    return {border_style, border_color, background_color, overdue_width}
  }, [data])

  const handleClick = e => {
    if (data.data.length === 1) {
      let _ev = data.data[0]
      if (_ev.type === 'GroupDateField') {
        _ev = {..._ev, field: entityFields.find(f => f.field_id === _ev.raw.field_id)}
      }
      stateCalEv.pop(_ev)
      return
    }

    const rect = e.currentTarget.getBoundingClientRect()
    const x = e.clientX - rect.x

    // add col offset to fill width
    const _x = x + data.colOffset
    const _col = Math.floor(_x / headers.primary[0].width) + data.colIndex
    const _moment = moment(headers.primary[_col].sec)
    stateEventDisplay.pop(
      {},
      {
        anchorPosition: {left: e.clientX, top: e.clientY},
        anchorEl: e.target,
        title: _moment.format(breakpoint.eventDisplayFormat.label),
        sub_title:
          !!breakpoint.eventDisplayFormat.label_sub &&
          _moment.format(breakpoint.eventDisplayFormat.label_sub),
      }
    )
  }

  const handleClickEvent = (e, ev) => {
    let _ev = ev
    if (ev.type === 'GroupDateField') {
      _ev = {..._ev, field: entityFields.find(f => f.field_id === ev.raw.field_id)}
    }
    stateCalEv.pop(_ev)
  }

  return (
    <>
      <div
        style={{
          left: data.left,
          width: data.width,
          borderStyle: border_style,
          borderColor: border_color,
          backgroundColor: background_color,
        }}
        className="c-pill ap-typography ap-typography--xxs ap-ellipsis"
        title={data.data.map(e => e.title).join('\n')}
        onClick={handleClick}
        data-x="date-selection"
      >
        <span
          style={{width: overdue_width > 0 ? `${100 - overdue_width}%` : 'auto'}}
          className="ap-ellipsis c-pill__label"
          data-x="date-selection"
        >
          {data.label}
        </span>
        {overdue_width > 0 && (
          <div style={{width: `${overdue_width}%`}} className="c-pill__overdue_bg ap-ellipsis ">
            <span className="ap-ellipsis c-pill__label" data-x="date-selection">
              Overdue
            </span>
          </div>
        )}
        {/* */}
      </div>
      <PopEventDisplay
        {...stateEventDisplay.props}
        data={data}
        onClose={e => stateEventDisplay.close()}
        onClickEvent={handleClickEvent}
      />
      {stateCalEv.props.data.type === 'SystemReservationAction' && (
        <CalendarEventReservationPopup {...stateCalEv.props} onClose={e => stateCalEv.close()} />
      )}
      {stateCalEv.props.data.type === 'ReservationAction' && (
        <CalendarEventDateDriveActionPopup
          {...stateCalEv.props}
          onClose={e => stateCalEv.close()}
        />
      )}
      {stateCalEv.props.data.type === 'GroupDateField' && (
        <CalendarEventGroupDatePopup {...stateCalEv.props} onClose={e => stateCalEv.close()} />
      )}
      {(stateCalEv.props.data.type === 'ActionDateField' ||
        stateCalEv.props.data.type === 'DefaultAction') && (
        <CalendarEventActionDatePopup {...stateCalEv.props} onClose={e => stateCalEv.close()} />
      )}
    </>
  )
}

export default Pill
